<div class="jumbotron">
    <h1>{{ i18n._133_PULSE | translate }}</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div
    class="container-fluid"
    [attr.aria-busy]="hasPendingData"
    [ngClass]="{ 'date-range': hasDateRangeAwareWidgets }"
>
    <div
        class="row"
        *ngIf="hasDateRangeAwareWidgets"
    >
        <div class="ml-auto col-4 col-md-3 col-lg-2 text-right mb-2">
            <label for="pulseDateRange">{{
                i18n._709_DATE_RANGE | translate
            }}</label>
            <select
                class="custom-select"
                id="pulseDateRange"
                [attr.aria-controls]="widgetIds"
                [ngModel]="selectedDateRange"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="informWidgets($event)"
            >
                <option
                    *ngFor="let i of dateRanges; let ii = index"
                    [value]="ii"
                >
                    {{ i.label }}
                </option>
            </select>
        </div>
    </div>
    <div
        class="row"
        *ngIf="!hasPendingData && groupConfig != null"
    >
        <div class="col-{{ groupConfig.width }}">
            <div class="row">
                <ng-template
                    ngFor
                    let-i
                    [ngForOf]="configs"
                >
                    <cmps-widget
                        class="col-{{ i.config?.width * 3 || 12 }} col-md-{{
                            i.config?.width * 1.5 || 6
                        }} col-lg-{{ i.config?.width || 4 }}"
                        [config]="i"
                    ></cmps-widget>
                </ng-template>
            </div>
        </div>
    </div>
</div>
